import { render, staticRenderFns } from "./origin-data.vue?vue&type=template&id=73e9d8de&scoped=true&"
import script from "./origin-data.vue?vue&type=script&lang=ts&"
export * from "./origin-data.vue?vue&type=script&lang=ts&"
import style0 from "./origin-data.vue?vue&type=style&index=0&id=73e9d8de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e9d8de",
  null
  
)

export default component.exports